exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Slide panel animations (matching FixedFeeEditPanel) */\n.slide-panel-enter-active[data-v-1085abce],\n.slide-panel-leave-active[data-v-1085abce] {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.slide-panel-enter-from[data-v-1085abce],\n.slide-panel-leave-to[data-v-1085abce] {\n  transform: translateX(100%);\n}\n.slide-panel-enter-to[data-v-1085abce],\n.slide-panel-leave-from[data-v-1085abce] {\n  transform: translateX(0);\n}\n", ""]);

// exports
